var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 96 96",
    style: {
      enableBackground: "new 0 0 96 96"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M72.129,26.94C65.525,20.336,54.978,20.022,48,25.995c-6.98-5.972-17.526-5.659-24.128,0.946 c-6.934,6.934-6.934,18.216,0,25.15l0.393,0.393L44.67,72.889c0.89,0.89,2.072,1.38,3.331,1.38c1.257,0,2.441-0.49,3.33-1.38 l20.799-20.798C79.062,45.157,79.062,33.874,72.129,26.94z M69.303,49.261l-20.801,20.8c-0.181,0.181-0.392,0.208-0.501,0.208 c-0.11,0-0.321-0.027-0.502-0.208L27.092,49.655L26.7,49.263c-5.374-5.375-5.374-14.12,0-19.494c5.375-5.374,14.119-5.374,19.494,0 l0.393,0.393c0.78,0.781,2.047,0.781,2.828,0l0.393-0.393c5.374-5.374,14.119-5.375,19.494,0 C74.674,35.143,74.674,43.888,69.303,49.261z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.48cee05b3c1e61f113bece54f857b85d.svg";
export { ForwardRef as ReactComponent };